export default __webpack_public_path__ + "static/media/peopleAmount.60256ba2.svg";